import { AppRoutesType } from 'config/types/navigation.type';
import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import NavigationUtils from '../utils/navigation.util';
import { routes } from './config.route';

const AppRoutes: React.FC = () => {
  NavigationUtils.history.navigate = useNavigate();

  return (
    <Routes>
      {routes.map((route: AppRoutesType, index: number) => (
        <Route key={`${route.path}-${index}`} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};
export default AppRoutes;
